module.exports = __webpack_public_path__ + "img/phone.d5826a84.svg";